import { CardWithHeader } from "@/components/card-with-header";
import { RefreshIconButton } from "@/components/refresh-icon-button";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { canAdminRead } from "@/lib/auth";
import { useQueryClient } from "@tanstack/react-query";
import {
  createFileRoute,
  Link,
  Outlet,
  redirect,
  useLocation,
} from "@tanstack/react-router";

export const Route = createFileRoute("/(app)/_admin-layout/admin_/compliance")({
  component: AdminComplianceLayout,
  beforeLoad: ({ location }) => {
    if (location.pathname === "/admin/compliance") {
      throw redirect({ to: "/admin/compliance/overview" });
    }
  },
});

function AdminComplianceLayout() {
  const context = Route.useRouteContext();
  const location = useLocation();
  const queryClient = useQueryClient();
  const hasReadAccess = canAdminRead(context.authorities);

  if (!hasReadAccess) {
    return (
      <CardWithHeader variant="exchange" label="Admin" title="Compliance">
        <div className="rounded-xl border border-slate-200 bg-slate-50 py-8 text-center text-slate-600">
          You do not have permission to view compliance data.
        </div>
      </CardWithHeader>
    );
  }

  return (
    <CardWithHeader
      variant="exchange"
      label="Admin"
      title="Compliance Management"
      headerContent={
        <RefreshIconButton
          label="Refresh admin compliance"
          onRefresh={() =>
            queryClient.refetchQueries({
              queryKey: ["compliance", "admin"],
            })
          }
        />
      }
    >
      <Tabs value={location.pathname.split("/").at(-1)}>
        <TabsList className="bg-transparent border-b border-slate-200 rounded-none p-0 h-auto w-full justify-start">
          <Link to="/admin/compliance/overview" preload="intent">
            <TabsTrigger
              value="overview"
              className="data-[state=active]:bg-transparent rounded-none px-4 py-2"
            >
              Overview
            </TabsTrigger>
          </Link>
          <Link to="/admin/compliance/cases" preload="intent">
            <TabsTrigger
              value="cases"
              className="data-[state=active]:bg-transparent rounded-none px-4 py-2"
            >
              Cases
            </TabsTrigger>
          </Link>
          <Link to="/admin/compliance/document-types" preload="intent">
            <TabsTrigger
              value="document-types"
              className="data-[state=active]:bg-transparent rounded-none px-4 py-2"
            >
              Requirements Configuration
            </TabsTrigger>
          </Link>
        </TabsList>
      </Tabs>
      <div className="mt-3">
        <Outlet />
      </div>
    </CardWithHeader>
  );
}
